import { render, staticRenderFns } from "./StoreDecoction.vue?vue&type=template&id=8d7658f8&"
import script from "./StoreDecoction.vue?vue&type=script&lang=js&"
export * from "./StoreDecoction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports